import React, { useState, useRef, useEffect } from 'react';
import './LanguageSwitcher.css';
import { FaGlobe } from 'react-icons/fa';
import { useLanguage } from '../../contexts/LanguageContext';

const LanguageSwitcher = ({ className = "" }) => {
  const { changeLanguage, language } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef();

  const availableLanguages = [
    { code: 'en', name: 'English',  english: 'English' },
    { code: 'fr', name: 'Français', english: 'French' },
    { code: 'ar', name: 'العربية',  english: 'Arabic' },
    { code: 'fa', name: 'فارسی',    english: 'Persian' },
    { code: 'es', name: 'Español',  english: 'Spanish' },
    { code: 'de', name: 'Deutsch',  english: 'German' },
    { code: 'tr', name: 'Türkçe',   english: 'Turkish' },
    { code: 'zh', name: '中文',       english: 'Chinese' },
    { code: 'ko', name: '한국어',     english: 'Korean' },
    { code: 'ru', name: 'Русский',   english: 'Russian' },
    { code: 'hi', name: 'हिन्दी',     english: 'Hindi' },
    { code: 'ur', name: 'اردو',       english: 'Urdu' },
  ];

  const handleToggle = () => setIsOpen(prev => !prev);
  const handleSelect = (code) => {
    changeLanguage(code);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className={`language-switcher-container ${className}`} ref={dropdownRef}>
      <button className="globe-btn" onClick={handleToggle} aria-label="Language Selector">
        <FaGlobe className="globe-icon" />
      </button>

      {isOpen && (
        <div className="language-dropdown">
          {availableLanguages.map((lang) => (
            <div
              key={lang.code}
              className={`language-option ${lang.code === language ? 'language-active' : ''}`}
              onClick={() => handleSelect(lang.code)}
            >
              <div className="lang-texts">
                <div className="lang-option-title">{lang.name}</div>
                <div className="lang-option-subtitle">{lang.english}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;